import React from "react";
import RouterLink from "gatsby-link";
import styled from "styled-components";

const Footer = () => (
  <StyledFooter>
    <P>
      © 2021 Jurek Barth | <Link to="/imprint">Imprint</Link>
    </P>
  </StyledFooter>
);

const StyledFooter = styled.footer`
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 1em;
`;

const P = styled.p`
  font-size: 0.7em;
`;

const Link = styled(RouterLink)`
  color: var(--black);
  text-decoration: none;
  &:hover,
  &:focus {
    color: var(--link-color);
    border-bottom: 1px solid var(--link-color);
  }
`;

export default Footer;



// WEBPACK FOOTER //
// ./src/components/Footer/index.js